module.exports = __webpack_public_path__ + "img/baoxiu.135a4711.png";